import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { Button } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import { closeModal as closeModalAction, ModalActions} from '../../../actions/modalActions';

interface SilageModalProps {
  onClose: (index?: number) => void;
  index?: number;
}

export const SilageModal = ({ onClose, index }: SilageModalProps) => (
  <div data-test-id="silage-modal">
    <div>{getMessage('silageModal.formulasSubtitle')}</div>
    <div>
      <ul>
        <li data-test-id="std-yield-formula">{getMessage('silageModal.formulas.stdYield')} = {getMessage('silageModal.formulas.dryYield')} / (1 - {getMessage('silageModal.formulas.nominalMoisture')})</li>
        <li data-test-id="wet-yield-formula">{getMessage('silageModal.formulas.wetYield')} = {getMessage('silageModal.formulas.wetWeight')} / {getMessage('silageModal.formulas.area')}</li>
        <li data-test-id="wet-weight-formula">{getMessage('silageModal.formulas.wetWeight')} = {getMessage('silageModal.formulas.wetWeightHarvested')}</li>
        <li data-test-id="dry-yield-formula">{getMessage('silageModal.formulas.dryYield')} = {getMessage('silageModal.formulas.dryWeight')} / {getMessage('silageModal.formulas.area')}</li>
        <li data-test-id="dry-weight-formula">{getMessage('silageModal.formulas.dryWeight')}= {getMessage('silageModal.formulas.wetWeight')} * (1 - ({getMessage('silageModal.formulas.cropMoisture')} / 100))</li>
        <li data-test-id="dry-matter-formula">{getMessage('silageModal.formulas.dryMatter')} % = 1 - {getMessage('silageModal.formulas.cropMoisture')}</li>
      </ul>    
    </div>
    <div>{getMessage('silageModal.nominalMoistureSubtitle')}</div>
    <div>
      <ul>
        <li data-test-id="default-moisture">{getMessage('silageModal.update.default')} = 65%.</li>
        <li>{getMessage('silageModal.update.change')}...</li>
        <ul data-test-id="update-moisture-steps">
          <li>{[
            getMessage('silageModal.update.step.1'),
            getMessage('silageModal.update.step.2'),
            getMessage('silageModal.update.step.3'),
            getMessage('silageModal.update.step.4'),
          ].join(' → ')}</li>
          <li data-test-id="update-warning">{getMessage('silageModal.update.warning')}</li>
        </ul>
      </ul>
    </div>
    <div>
      <Button mode="link" onClick={() => onClose(index)} data-test-id="close-modal-button">
        {getMessage('silageModal.ok')}
      </Button>
    </div>
  </div>
);

function mapDispatchToProps(dispatch: Dispatch<ModalActions>) {
  return bindActionCreators(
    {
      closeModalAction,
    },
    dispatch
  );
}

export default connect(undefined, mapDispatchToProps)(SilageModal);